"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAlert = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Box_1 = __importDefault(require("../Box"));
var Link_1 = __importDefault(require("../Link"));
var FontAwesomeIcon_1 = require("../FontAwesomeIcon");
var Flex_1 = require("../Flex");
var AlertBody_1 = __importStar(require("./components/AlertBody"));
var AlertIcon_1 = __importDefault(require("./components/AlertIcon"));
var AlertCloseButton_1 = __importStar(require("./components/AlertCloseButton"));
var allowedColors = ["primary", "secondary", "success", "danger", "warning"];
exports.StyledAlert = styled_components_1.default(function (_a) {
    var visible = _a.visible, props = __rest(_a, ["visible"]);
    return (react_1.default.createElement(Box_1.default, __assign({}, props)));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  position: relative;\n  border-radius: ", ";\n  color: ", " !important;\n  background: ", " !important;\n  border: 1px solid ", ";\n  ", "\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  position: relative;\n  border-radius: ", ";\n  color: ", " !important;\n  background: ", " !important;\n  border: 1px solid ", ";\n  ",
    "\n  ",
    ";\n\n  ",
    ";\n"])), style_utils_1.setAlignItems("center"), style_utils_1.setDisplay("flex"), style_utils_1.setTransition("opacity 0.15s linear"), style_utils_1.setMargin("bottom", 3), style_utils_1.setPadding("y", 3), style_utils_1.getBorderRadius(), style_utils_1.getColor("gray", 900), style_utils_1.getColor("gray", 0), style_utils_1.getColor("gray", 100), function (props) {
    return props.rtl
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          border-right: 0.5rem solid\n            ", ";\n          ", ";\n          ", ";\n        "], ["\n          border-right: 0.5rem solid\n            ", ";\n          ", ";\n          ", ";\n        "])), function () { return style_utils_1.colorSelector(props, props.color, 500); }, style_utils_1.setPadding("right", 3), style_utils_1.setPadding("left", props.$canBeToggle ? 5 : 3)) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          border-left: 0.5rem solid\n            ", ";\n          ", ";\n          ", ";\n        "], ["\n          border-left: 0.5rem solid\n            ", ";\n          ", ";\n          ", ";\n        "])), function () { return style_utils_1.colorSelector(props, props.color, 500); }, style_utils_1.setPadding("right", props.$canBeToggle ? 5 : 3), style_utils_1.setPadding("left", 3));
}, function (props) {
    return !props.visible && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n       {\n        display: none !important;\n      }\n    "], ["\n       {\n        display: none !important;\n      }\n    "])));
}, function (props) {
    return props.system && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", " !important;\n      background: ", " !important;\n      border: 1px solid ", ";\n      left: 0;\n      right: 0;\n      position: absolute;\n      z-index: 1029;\n\n      ", " {\n        flex: 1 1 auto;\n        flex-direction: row !important;\n        font-size: 1.142857rem;\n        font-weight: 500;\n      }\n\n      ", ",\n      ", ",\n      ", ",\n      ", ",\n      ", " {\n        color: ", " !important;\n      }\n      \n      a,\n      ", " {\n        text-decoration: underline;\n        display: inline-block;\n      }\n    "], ["\n      color: ", " !important;\n      background: ", " !important;\n      border: 1px solid ", ";\n      left: 0;\n      right: 0;\n      position: absolute;\n      z-index: 1029;\n\n      ", " {\n        flex: 1 1 auto;\n        flex-direction: row !important;\n        font-size: 1.142857rem;\n        font-weight: 500;\n      }\n\n      ", ",\n      ", ",\n      ", ",\n      ", ",\n      ", " {\n        color: ", " !important;\n      }\n      \n      a,\n      ", " {\n        text-decoration: underline;\n        display: inline-block;\n      }\n    "])), style_utils_1.getColor("gray", 0), style_utils_1.colorSelector(props, props.color, 500), style_utils_1.colorSelector(props, props.color, 500), AlertBody_1.StyledAlertBody, AlertBody_1.StyledAlertBody, AlertCloseButton_1.StyledAlertCloseButton, FontAwesomeIcon_1.StyledFontAwesomeIcon, Flex_1.StyledFlex, Link_1.default, style_utils_1.getColor("gray", 0), Link_1.default);
});
var Alert = function (_a) {
    var canBeToggled = _a.canBeToggled, children = _a.children, color = _a.color, onClose = _a.onClose, rtl = _a.rtl, system = _a.system, props = __rest(_a, ["canBeToggled", "children", "color", "onClose", "rtl", "system"]);
    var _b = __read(react_1.default.useState(true), 2), visible = _b[0], setVisible = _b[1];
    var propColor = allowedColors.includes(color) ? color : "primary";
    var onDismiss = function (e) {
        setVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
    };
    return (react_1.default.createElement(exports.StyledAlert, __assign({ visible: visible, color: propColor, rtl: rtl, system: system, "$canBeToggle": canBeToggled }, props),
        react_1.default.createElement(AlertCloseButton_1.default, { canBeToggled: canBeToggled, onClick: onDismiss, rtl: rtl }),
        !system && react_1.default.createElement(AlertIcon_1.default, { color: propColor }),
        react_1.default.createElement(AlertBody_1.default, { justifyContent: system ? "center" : undefined }, children)));
};
Alert.defaultProps = {
    color: "primary"
};
exports.default = Alert;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map